import React from 'react';

import Layout from 'layouts/Layout';
import CartList from './CartList';

const CartListLayout = ({ match }) => <Layout component={CartList} match={match} />;

export default CartListLayout;
